const entryActions = {
  CLEAR: "CLEAR",
  UPDATE_CHALLENGE_RESPONSE: "UPDATE_CHALLENGE_RESPONSE",
  UPDATE_EMAIL: "UPDATE_EMAIL",
  UPDATE_ERROR: "UPDATE_ERROR",

  clear() {
    return { type: this.CLEAR };
  },
  updateEmail(email) {
    return { type: this.UPDATE_EMAIL, email };
  },
  updateChallengeResponse(challengeResponse) {
    return { type: this.UPDATE_CHALLENGE_RESPONSE, challengeResponse };
  },
  updateError(error) {
    return { type: this.UPDATE_ERROR, error };
  },
};

export default entryActions;
